import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
// MUI
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import { red } from "@mui/material/colors";
import Checkbox from "@mui/material/Checkbox";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import FormHelperText from '@mui/material/FormHelperText';

//API
import { API } from "../../config";
import { getAPI, fni18n } from "../../services/commonService";

import { theme } from '../../assets/themes';

const MenuDetailPage = (props) => {
    const { t } = useTranslation();
    const [menuCombo, setMenuCombo] = useState([]); // 메뉴콤보박스

    useEffect(() => {
        try {
            loadPMenuListCombo()
      } catch (e) {
        console.log(e);
      }
    }, [])

    /**
    * 콤보박스 로드
    */
    const loadPMenuListCombo = async () => {
        try {
           await getAPI(API.SYSTEM.PMENU)
            .then((res) => {
                setMenuCombo(res.data.result);
            })
            .catch((err) =>{
                console.log("loadPMenuCombo() Error! ", err);
            });
        } catch (e) {
            console.log(e);
        }        
    };
    return (
    <div className="pop-container">
        {/* 상단메뉴명 */}
        <div className="header">
            {fni18n('메뉴 설정')}
        </div>
        <div className="contents">
        <TableContainer className="table-container" component={Paper} elevation={0}>
            <Table className="table" size="small">
                <TableBody>
                <TableRow>
                    <TableCell className="table-cell-title">{fni18n('메뉴번호')}</TableCell>
                    <TableCell className="table-cell">
                        <FormControl>
                            <TextField
                            type="text"
                            size="small"
                            placeholder="new"
                            name="menuNo"
                            value={props.data.menuNo || ""}
                            disabled
                            onChange={e => props.onChange(e)}
                            InputProps={{
                            readOnly: true,
                            }}
                            />
                        </FormControl> 
                    </TableCell>
                    <TableCell className="table-cell-title">{fni18n('메뉴명')}</TableCell>
                    <TableCell className="table-cell">
                        <FormControl>
                            <TextField
                                type="text"
                                size="small"
                                name="menuNm"
                                value={t(props.data.menuNm) || ""}
                                onChange={e => props.onChange(e)}
                                error={props.showError && props.errors.menuNm}
                                helperText={props.errors.menuNm || ""}
                            />
                        </FormControl>
                    </TableCell>
                    <TableCell className="table-cell-title">{fni18n('메뉴경로')}</TableCell>
                    <TableCell className="table-cell">
                        <FormControl>
                            <TextField
                            type="text"
                            size="small"
                            hiddenLabel
                            name="menuUrl"
                            value={props.data.menuUrl || ""}
                            onChange={e => props.onChange(e)}
                            />
                        </FormControl>
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableCell className="table-cell-title">{fni18n('상위메뉴')}</TableCell>
                    <TableCell className="table-cell">
                        <FormControl size="small" >
                            <Select
                            sx={{ minWidth: 200 }}
                            id="cbx_menuList"
                            name="pmenuNo"
                            value={props.data.pmenuNo || ""}
                            onChange={e => props.onChange(e)}
                            disabled={props.data.menuNo !== 'new'}
                            // inputProps={{ readOnly: props.data.menuNo !== 'new' }}
                            >
                                <MenuItem value="">{fni18n('새 상위메뉴')}</MenuItem>
                                {menuCombo.map((menu) => (
                                <MenuItem key={menu.MENU_NO} value={menu.MENU_NO}>
                                    {menu.MENU_NO} - {fni18n(menu.MENU_NM)}
                                </MenuItem>
                                ))}
                            </Select>
                            {/* <FormHelperText error={props.showError && props.errors.pmenuNo && props.data.menuNo === 'new'}>{props.errors.pmenuNo || ""}</FormHelperText> */}
                        </FormControl>
                    </TableCell>
                    <TableCell className="table-cell-title">{fni18n('순번')}</TableCell>
                    <TableCell className="table-cell">
                        <FormControl>
                            <TextField
                                type="number"
                                size="small"
                                hiddenLabel
                                name="menuSeqNo"
                                value={props.data.menuSeqNo || ""}
                                onChange={e => props.onChange(e)}
                                inputProps={{maxLength : 2}}
                            />
                        </FormControl>
                    </TableCell>
                    <TableCell className="table-cell-title">{fni18n('사용여부')}</TableCell>
                    <TableCell className="table-cell">
                        <FormControlLabel
                        control={
                            <Checkbox
                            name="visblYn"
                            checked={props.data.visblYn === "Y" ? true : false}
                            onChange={e => props.onSwitchChange(e)}
                            />
                        }
                        />
                    </TableCell>
                </TableRow>
                </TableBody>            
            </Table>
        </TableContainer>
        </div>
    </div>

    )
}

export default MenuDetailPage;